import { render, staticRenderFns } from "./RecoveryPanel.vue?vue&type=template&id=50a10ed0&scoped=true&"
import script from "./RecoveryPanel.vue?vue&type=script&lang=js&"
export * from "./RecoveryPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a10ed0",
  null
  
)

export default component.exports